/* eslint-disable no-nested-ternary */
import React from "react";
import Carousel from "react-multi-carousel";
import { classNames } from "repoV2/utils/common/render/classNames";
import { isEmpty } from "@Utils";
import VideoPlayer from "repoV2/components/common/VideoPlayer/VideoPlayer";
import { get32BitIntegerCode } from "repoV2/features/Common/modules/Hashing/utils/32BitIntegerCode";
import ExlyImage from "repoV2/features/Common/modules/ExlyImage/ExlyImage";
import { IEventMedia } from "./EventMedia";
import styles from "./eventMedia.module.scss";

const responsive = {
    all: {
        breakpoint: { max: 4000, min: 0 },
        items: 1,
    },
};

const EventMedia = ({
    mediaType,
    video,
    carouselImages,
    image,
    wrapperComponentType,
}: IEventMedia.IProps): JSX.Element => {
    const commonStyle =
        wrapperComponentType === "modal" && styles.shrinkForModal;

    if (mediaType === "video" && video) {
        return (
            <VideoPlayer
                videoUrl={video}
                id="eventMedia-coverVideo"
                controls
                height="100%"
                width="100%"
                // playsinline prevents video to default open in full screen in ios
                playsinline
                className={classNames(styles.video, commonStyle)}
            />
        );
    }

    if (mediaType === "imageCarousel" && !isEmpty(carouselImages)) {
        return (
            <Carousel
                containerClass={classNames(
                    styles.carouselContainer,
                    commonStyle
                )}
                infinite
                showDots
                responsive={responsive}
                dotListClass={styles.carouselDots}
                autoPlay
                transitionDuration={1000}
            >
                {carouselImages.map((imageUrl: string, index) =>
                    imageUrl ? (
                        <ExlyImage
                            src={imageUrl}
                            fetchWidth={750}
                            width={750} // event page has no limit on max width
                            key={get32BitIntegerCode(`${imageUrl}=${index}`)}
                            className={classNames(styles.image, commonStyle)}
                        />
                    ) : null
                )}
            </Carousel>
        );
    }

    return (
        <ExlyImage
            src={image}
            fetchWidth={750}
            width={750} // event page has no limit on max width
            className={classNames(styles.image, commonStyle)}
        />
    );
};

export default EventMedia;
